import React from "react";
import ContentCardsBlade, { IContentCard } from "@organic-return/foundation-react/src/components/Blades/ContentCardsBlade";

const ThreeColumnCards = ({ module }) => {

    const { customFields } = module;

    let cards: IContentCard[] = [];

    (customFields.titleOne || customFields.imageOne || customFields.textOne)
        && cards.push({
            header: customFields.titleOne,
            text: customFields.textOne,
            image: { url: customFields.imageOne?.url ?? undefined },
            link: customFields.linkOne ? { url: customFields.linkOne.href, label: customFields.linkOne.label } : undefined
        });

    (customFields.titleTwo || customFields.imageTwo || customFields.textTwo)
        && cards.push({
            header: customFields.titleTwo,
            text: customFields.textTwo,
            image: { url: customFields.imageTwo?.url ?? undefined },
            link: customFields.linkTwo ? { url: customFields.linkTwo.href, label: customFields.linkTwo.label } : undefined
        });

    (customFields.titleThree || customFields.imageThree || customFields.textThree)
        && cards.push({
            header: customFields.titleThree,
            text: customFields.textThree,
            image: { url: customFields.imageThree?.url ?? undefined },
            link: customFields.linkthree ? { url: customFields.linkthree.href, label: customFields.linkthree.label } : undefined
        });

    return (
        <div className="relative max-w-screen-xl mx-auto px-2 lg:px-3 xl:px-8 three-cols-cards">
            <ContentCardsBlade
                contentCards={cards}
                title={customFields.title}
                headingCTA={customFields.headingCTA}
            />
        </div>
    );
}

export default ThreeColumnCards;